/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profilesettings': {
    width: 13,
    height: 13,
    viewBox: '0 0 13 13',
    data: '<path pid="0" d="M6.54.154a6.109 6.109 0 0 1 6.122 6.124A6.109 6.109 0 0 1 6.54 12.4 6.109 6.109 0 0 1 .416 6.278 6.109 6.109 0 0 1 6.539.154zm0 5.052a1.633 1.633 0 1 1 0-3.266 1.633 1.633 0 0 1 0 3.266zm4.005 4.695c.867-.97 1.403-2.22 1.403-3.623A5.412 5.412 0 0 0 6.54.868a5.412 5.412 0 0 0-5.409 5.41c0 1.403.536 2.653 1.404 3.623.51-1.735 2.117-3.011 4.005-3.011s3.496 1.276 4.006 3.01z" _fill="#2B2A29" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/profilesettings.js